import { formatDistanceToNow, format } from 'date-fns';

const normalizeConfidencePercent = (confidence: number | undefined): number | undefined => {
  if (confidence === undefined || confidence === null || Number.isNaN(confidence)) {
    return undefined;
  }
  if (confidence <= 1) {
    return confidence * 100;
  }
  return confidence;
};

export const formatCurrency = (amount: number, currency: string = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
};

export const formatNumber = (num: number, decimals: number = 2): string => {
  return Number.isInteger(num) ? num.toString() : num.toFixed(decimals);
};

export const formatConfidence = (confidence: number | undefined): string => {
  const normalizedConfidence = normalizeConfidencePercent(confidence);
  if (!normalizedConfidence) return 'N/A';
  return `${Math.round(normalizedConfidence)}%`;
};

export const formatDate = (date: string | Date): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'MMM dd, yyyy');
};

export const formatDateTime = (date: string | Date): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'MMM dd, yyyy HH:mm');
};

export const formatRelativeTime = (date: string | Date): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return formatDistanceToNow(dateObj, { addSuffix: true });
};

export const getConfidenceColor = (confidence: number | undefined): string => {
  const normalizedConfidence = normalizeConfidencePercent(confidence);
  if (!normalizedConfidence) return 'gray';
  if (normalizedConfidence >= 90) return 'green';
  if (normalizedConfidence >= 70) return 'yellow';
  return 'red';
};

export const getStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'approved':
    case 'matched':
    case 'success':
      return 'green';
    case 'pending_review':
    case 'pending':
      return 'yellow';
    case 'rejected':
    case 'failed':
      return 'red';
    default:
      return 'gray';
  }
};

export const truncate = (str: string, length: number = 50): string => {
  return str.length > length ? `${str.substring(0, length)}...` : str;
};
